
import { SearchIcon, SettingsIcon, InboxIcon } from 'lucide-react';
import React from 'react';

import {
    AnalyticsIcon,
    LeadsIcon,
    PlaybookIcon,
    PropertiesIcon,
    ShowingIcon,
    TeamIcon,
    SnippetsIcon,
} from 'src/icons';

export const links = [
    { text: 'Inbox', icon: <InboxIcon size={22} />, link: '/landlord/inner/messages' },
    { text: 'Search', icon: <SearchIcon size={22} />, link: '/landlord/inner/archive' },
    { text: 'Leads', icon: <LeadsIcon />, link: '/landlord/inner/leads/all' },
    { text: 'Playbooks', icon: <PlaybookIcon />, link: '/landlord/inner/playbooks' },
    { text: 'Snippets', icon: <SnippetsIcon />, link: '/landlord/inner/snippets' },
    { text: 'Properties', icon: <PropertiesIcon />, link: '/landlord/inner/properties' },
    { text: 'Tours', icon: <ShowingIcon />, link: '/landlord/inner/tours' },
    { text: 'Analytics', icon: <AnalyticsIcon />, link: '/landlord/inner/analytics' },
    { text: 'Team', icon: <TeamIcon />, link: '/landlord/inner/team' },
    { text: 'Settings', icon: <SettingsIcon />, link: '/landlord/inner/settings' },
];